import { typography, colors, size } from '@everlywell/leaves';
import styled from 'styled-components';

export const Wrapper = styled.div`
  h1 {
    color: ${colors.teal4};
    font-size: 32px;
    line-height: 32px;
    font-weight: ${typography.weight.xbold};
    letter-spacing: 0.4px;
    margin-bottom: 20px;
  }

  h2 {
    color: ${colors.teal4};
    font-size: 25px;
    line-height: 32px;
    font-weight: ${typography.weight.bold};
    letter-spacing: 0.53px;
    margin: 20px 0 10px;
  }

  h3 {
    color: ${colors.teal4};
    font-size: 20.25px;
    line-height: 28px;
    letter-spacing: 0.23px;
    margin: 30px 0 20px;
  }

  h4 {
    color: ${colors.teal4};
    font-size: 18px;
    margin: 20px 0 10px;
  }

  p {
    ${typography.bodyTextSmall};
    margin-bottom: 10px;
    line-height: 26px;
  }

  a {
    font-weight: ${typography.weight.bold};
    color: ${colors.green5};
  }

  ol {
    li {
      list-style-type: decimal;
    }
  }

  ul {
    li {
      list-style: inside;
      margin-bottom: 10px;
      line-height: 26px;
      padding-left: 20px;

      p {
        display: inline;
      }
    }
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: auto;
    width: 100%;
    margin-bottom: 20px;

    td,
    th {
      border: 1px solid ${colors.black};
      padding: ${size.sm}px;
    }

    th {
      color: ${colors.teal4};
      margin: 0;
      text-align: left;
      font-weight: ${typography.weight.bold};
    }

    td {
      font-weight: ${typography.weight.regular};
      font-size: 1rem;
      letter-spacing: 0.25px;
      line-height: 26px;
    }
  }

  hr {
    border-bottom: 1px solid ${colors.gray2};
    margin: 20px 0;
  }

  .underline {
    text-decoration: underline;
  }

  .pointer {
    cursor: pointer;
  }

  strong {
    font-weight: bold;
  }
`;

export const Bold = styled.span`
  font-weight: ${typography.weight.bold};
`;

export const Underline = styled.span`
  text-decoration: underline;
`;

export const Paragraph = styled.p`
  ${typography.bodyText};
`;
